import { EchartsWithTheme, Empty, useTheme } from '@maxtropy/components';
import { isNil } from 'lodash-es';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { ShareDataWrapperContext } from '../..';
import { getChartOption } from './chart';
import styles from './index.module.scss';
import steam_bg from '../../../../imgs/steam_bg.png';
import { formatThousandUnitDefaultTwo, keepTwoOrLine } from '@/utils/utils';
import { configuredListData, gasConfigList } from '@/pages/EnergyStatisticalReport/const';

const AirSteamBox = () => {
  const theme = useTheme();
  const { overviewData, loading } = useContext(ShareDataWrapperContext);
  const [pieLegendData, setPieLegendData] = useState<any[]>();

  // 图表
  const chartOption = useMemo(() => {
    return getChartOption(pieLegendData);
  }, [pieLegendData]);

  useEffect(() => {
    const gasInfo = overviewData?.gasInfo;
    const configuredList = gasConfigList
      .filter(config => {
        const gasData = gasInfo?.[config.key as keyof typeof gasInfo] as configuredListData;
        return gasData && gasData.hasConfig === true;
      })
      .map(config => {
        const gasData = gasInfo?.[config.key as keyof typeof gasInfo] as configuredListData;
        return {
          name: `${config.name}成本`,
          value: gasData.cost,
          rate: gasData.costRatio,
          color: config.color,
        };
      })
      .filter(item => item !== null && item.value !== 0);
    setPieLegendData(configuredList);
  }, [overviewData]);

  // 判断是否有数据
  const hasData = useMemo(() => {
    return (pieLegendData ?? []).length > 0;
  }, [pieLegendData]);

  return (
    <div className={styles.elecWater_wrapper}>
      <div className={styles.elec_wrapper}>
        <div className={styles.top}>
          <div className={styles.title}>用气成本</div>
          <div className={styles.value}>
            <div className={styles.label}>占比：</div>
            <div className={styles.rate}>{keepTwoOrLine(overviewData?.gasInfo?.totalCostRatio)}%</div>
          </div>
        </div>
        <div className={styles.bottom}>
          {!hasData ? (
            <div className={styles.empty_wrapper}>
              <Empty />
            </div>
          ) : (
            <>
              <div className={styles.chart_wrapper}>
                <EchartsWithTheme
                  loading={loading}
                  type="pie"
                  theme={theme}
                  style={{ height: 180, width: '100%' }}
                  option={chartOption}
                />
              </div>
              <div className={styles.customer_legend}>
                {(pieLegendData ?? []).map(item => (
                  <div className={styles.legend_item} key={item.name}>
                    <div className={styles.icon} style={{ backgroundColor: item.color }}></div>
                    <div className={styles.label}>{item.name ?? '--'}</div>
                    <div className={styles.value}>{formatThousandUnitDefaultTwo(item.value)}元</div>
                    <div className={styles.rate}>{keepTwoOrLine(item.rate)}%</div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AirSteamBox;
